import { render } from "./TagRenderer.vue?vue&type=template&id=d2d3604a"
import script from "./TagRenderer.vue?vue&type=script&lang=js"
export * from "./TagRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__